import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { PaystubsService } from '@paystubs/paystubs.service';
import { TabComponent } from './tab/tab.component';

@Component({
  selector: 'sp-tabs',
  template: `
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" role="presentation" *ngFor="let tab of tabs" (click)="selectTab(tab)">
          <a #navLinks [class.active]="tab.active">
            <button class="nav-link">
              <h5>{{ tab.title }}</h5>
            </button>
          </a>
        </li>
      </ul>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  //contentChildren are set
  constructor(private cdr: ChangeDetectorRef, private paystubsService: PaystubsService) {}

  ngAfterContentInit() {
    //get all active tabs
    const activeTabs = this.tabs.filter(tab => tab.active);

    //if there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }

    this.cdr.detectChanges();
  }

  selectTab(tab: TabComponent) {
    //deactivate all tabs
    if (tab) {
      this.tabs.toArray().forEach(tab => (tab.active = false));
      //activate the tab the user has clicked on.
      this.paystubsService.addTabTitle(tab.title);
      tab.active = true;
    } else {
      this.paystubsService.addTabTitle(`${new Date().getFullYear()}`);
    }
  }
}
